import { BehaviorSubject } from 'rxjs';
import equal from 'Angular/utils/equal/deep-equal';
/**
 * Service that fetches a collection of folderable items.
 */
export class FolderableCollectionServiceBase {
    constructor() {
        this.viewRootFolder = null;
        this.items = [];
        this.dataParams = null;
        this.userHasNoData = false;
        this.loading = false;
        this.showLoading = false;
        this.viewResponse = new BehaviorSubject(null);
        this.viewResponse$ = this.viewResponse.asObservable();
        this.folderableCollectionSubscription = null;
    }
    get textSearchActive() {
        return this.dataParams ? !!this.dataParams.name : false;
    }
    /**
     * Load folderable items.
     *
     * By default, fetches items from the following page.
     * When `paginate` is false, data is fetched with the same parameters.
     */
    loadItems(showLoading = false) {
        if (this.folderableCollection$ === null)
            return;
        this.showLoading = showLoading;
        this.loading = true;
        // Prevent making unnecessary requests on page load and when the user quickly clicks on column headers.
        if (this.folderableCollectionSubscription !== null)
            this.folderableCollectionSubscription.unsubscribe();
        this.folderableCollectionSubscription = this.folderableCollection$.subscribe({
            next: (viewResponse) => {
                this.viewRootFolder = viewResponse.viewRootFolder;
                this.items = viewResponse.data.items;
                this.loading = false;
                // Default back to not showing the loading symbol
                this.showLoading = false;
                this.userHasNoData = viewResponse.userHasNoData;
                this.viewResponse.next(viewResponse);
            },
            error: (err) => {
                this.viewResponse.error(err);
                this.items = [];
                this.loading = false;
                // Default back to not showing the loading symbol
                this.showLoading = false;
                this.userHasNoData = false;
            },
        });
    }
    refreshData(dataParams, force = false) {
        if (!force && equal(this.dataParams, dataParams))
            return;
        if (dataParams !== undefined) {
            this.dataParams = dataParams;
        }
        this.loadItems(this.items.length === 0);
    }
}
